import { createFeatureSelector, createSelector } from "@ngrx/store";
import { SalutacionState } from "./salutacion.reducers";
import * as fromSalutacion from './salutacion.reducers';

export const salutacionState = createFeatureSelector<SalutacionState>("salutacion");

export const allSalutacion = createSelector(
	salutacionState,
	fromSalutacion.selectAll
);

export const salutacionReady = createSelector(
	salutacionState,
	state => state.ready
);

export const salutacionStatus = createSelector(
	salutacionState,
	state => state.status
);

export const salutacionNextPageNum = createSelector(
	salutacionState,
	state => state.nextPageNum
);

export const salutacionPageSize = createSelector(
	salutacionState,
	state => state.pageSize
)